import {CodeAndExchange} from "../../../../../../instruments/types/CodeAndExchange";
import {TimeSeriesPeriod} from "../../../../../../security/time-series/types/TimeSeriesPeriod";

export interface TimeSeriesWidgetConfig {
    readonly security?: CodeAndExchange;
    readonly period?: TimeSeriesPeriod;
    readonly adjusted?: boolean;
}

export type TimeSeriesConfigUpdate = Partial<TimeSeriesWidgetConfig>;

export function defaultConfig(): TimeSeriesWidgetConfig {
    return {
        period: TimeSeriesPeriod.DAILY,
        adjusted: true
    };
}
